// Define the Project interface
export interface Project {
  id: string;
  category: string;
  image: string;
  featured: boolean;
  year: string;
  translations: {
    [key: string]: {
      title: string;
      client: string;
      location: string;
      description: string;
    };
  };
}

// Function to create project data with translations directly included
export const createProjectsData = (): Project[] => {
  return [
    {
      id: 'project-building-renovation-zones-industrielles',
      category: 'renovation',
      image: 'projet-building-renovation-1.webp',
      featured: true,
      year: '2025',
      translations: {
        en: {
          title: 'Renovation of Industrial Zone Building',
          client: 'Confidential Industrial Client',
          location: 'Tangier, Morocco',
          description: 'Complete renovation and modernization of a prefabricated industrial office building, including structural repairs, façade updates, and installation of sunshade structures.'
        },
        fr: {
          title: 'Rénovation d’un bâtiment en zone industrielle',
          client: 'Client industriel confidentiel',
          location: 'Tanger, Maroc',
          description: 'Rénovation complète et modernisation d’un bâtiment de bureaux préfabriqué en zone industrielle, incluant des réparations structurelles, la mise à jour de la façade et l’installation de pare-soleil.'
        },
        ar: {
          title: 'تجديد مبنى في منطقة صناعية',
          client: 'عميل صناعي',
          location: 'طنجة، المغرب',
          description: 'تجديد شامل وتحديث لمبنى مكاتب صناعي مُسبق الصنع، يشمل إصلاحات هيكلية، تحديث الواجهة، وتركيب هياكل واقية من الشمس.'
        }
      }
    },
    {
      id: 'project-industrial-pump-maintenance',
      category: 'maintenance',
      image: 'project_pompes.webp',
      featured: false,
      year: '2025',
      translations: {
        en: {
          title: 'Installation and Maintenance of Industrial Pumps',
          client: 'Industrial Manufacturing Facility',
          location: 'Tangier, Morocco',
          description: 'Installation and maintenance of industrial pumps used in hydraulic and cooling systems, including connection, commissioning, and performance optimization to ensure system reliability and efficiency.'
        },
        fr: {
          title: 'Installation et maintenance des pompes industrielles',
          client: 'Site industriel de fabrication',
          location: 'Tanger, Maroc',
          description: 'Installation et maintenance de pompes industrielles pour les systèmes hydrauliques et de refroidissement, incluant le raccordement, la mise en service et l’optimisation du rendement afin d’assurer la fiabilité et la performance des installations.'
        },
        ar: {
          title: 'تركيب وصيانة المضخات الصناعية',
          client: 'منشأة صناعية',
          location: 'طنجة، المغرب',
          description: 'تركيب وصيانة المضخات الصناعية المستخدمة في أنظمة الهيدروليك والتبريد، بما في ذلك التوصيل والتشغيل وتحسين الأداء لضمان موثوقية وكفاءة النظام.'
        }
      }
    },
    {
      id: 'project-piscine-200-160',
      category: 'pools',
      image: 'projet-pool-2.webp',
      featured: true,
      year: '2022',
      translations: {
        en: {
          title: 'Construction of Two Complete Swimming Pools',
          client: 'Private Client',
          location: 'Tangier, Morocco',
          description: 'Design and construction of two swimming pools of 200 m³ and 160 m³, including modern filtration and lighting systems for an optimal swimming experience.'
        },
        fr: {
          title: 'Réalisation de deux piscines complètes',
          client: 'Client Privé',
          location: 'Tanger, Maroc',
          description: 'Conception et construction de deux piscines de 200 m³ et 160 m³, incluant des systèmes de filtration et d’éclairage modernes pour une expérience de baignade optimale.'
        },
        ar: {
          title: 'بناء حمامي سباحة كاملين',
          client: 'عميل خاص',
          location: 'طنجة، المغرب',
          description: 'تصميم وبناء حمامي سباحة بسعة 200 م³ و160 م³، مزودين بأنظمة ترشيح وإضاءة حديثة لتجربة سباحة مثالية.'
        }
      }
    },
    {
      id: 'project-entretien-piscines',
      category: 'pools',
      image: 'projet-pool-1.webp',
      featured: true,
      year: '2021-2024',
      translations: {
        en: {
          title: 'Maintenance and Cleaning of Over 50 Swimming Pools',
          client: 'Various Residential and Commercial Clients',
          location: 'Tangier, Morocco',
          description: 'Regular maintenance and cleaning services for over 50 swimming pools, ensuring clean water and well-maintained facilities throughout the year.'
        },
        fr: {
          title: 'Entretien et nettoyage de plus de 50 piscines',
          client: 'Divers Clients Résidentiels et Commerciaux',
          location: 'Tanger, Maroc',
          description: 'Services réguliers d’entretien et de nettoyage pour plus de 50 piscines, garantissant une eau propre et des installations en bon état tout au long de l’année.'
        },
        ar: {
          title: 'صيانة وتنظيف أكثر من 50 حمام سباحة',
          client: 'عملاء سكنيون وتجاريون متنوعون',
          location: 'طنجة، المغرب',
          description: 'خدمات صيانة وتنظيف دورية لأكثر من 50 حمام سباحة، مما يضمن مياهًا نظيفة ومرافق جيدة الصيانة طوال العام.'
        }
      }
    },
    {
      id: 'project-station-traitement-eaux',
      category: 'waterTreatment',
      image: 'project-station-1.webp',
      featured: true,
      year: '2024',
      translations: {
        en: {
          title: 'Construction of Two Domestic Wastewater Treatment Stations',
          client: 'Local Municipality',
          location: 'Tangier, Morocco',
          description: 'Installation of two domestic wastewater treatment stations to improve water resource management and reduce environmental impact.'
        },
        fr: {
          title: 'Réalisation de deux stations de traitement des eaux usées domestiques',
          client: 'Municipalité Locale',
          location: 'Tanger, Maroc',
          description: 'Installation de deux stations de traitement des eaux usées domestiques pour améliorer la gestion des ressources en eau et réduire l’impact environnemental.'
        },
        ar: {
          title: 'بناء محطتين لمعالجة مياه الصرف الصحي المنزلي',
          client: 'البلدية المحلية',
          location: 'طنجة، المغرب',
          description: 'تركيب محطتين لمعالجة مياه الصرف الصحي المنزلي لتحسين إدارة موارد المياه وتقليل الأثر البيئي.'
        }
      }
    },
    {
      id: 'project-station-eh',
      category: 'waterTreatment',
      image: 'project-station-3.webp',
      featured: false,
      year: '2023',
      translations: {
        en: {
          title: 'Wastewater Treatment Stations of 400 EH and 20 EH',
          client: 'Industrial Company',
          location: 'Tangier, Morocco',
          description: 'Design and implementation of wastewater treatment stations with capacities of 400 EH and 20 EH to meet industrial and environmental needs.'
        },
        fr: {
          title: 'Stations de traitement des eaux usées de 400 EH et 20 EH',
          client: 'Entreprise Industrielle',
          location: 'Tanger, Maroc',
          description: 'Conception et mise en œuvre de stations de traitement des eaux usées de capacités 400 EH et 20 EH pour répondre aux besoins industriels et environnementaux.'
        },
        ar: {
          title: 'محطات معالجة مياه الصرف الصحي بسعة 400 وحدة مكافئة و20 وحدة مكافئة',
          client: 'شركة صناعية',
          location: 'طنجة، المغرب',
          description: 'تصميم وتنفيذ محطات معالجة مياه الصرف الصحي بسعات 400 وحدة مكافئة و20 وحدة مكافئة لتلبية الاحتياجات الصناعية والبيئية.'
        }
      }
    },
    {
      id: 'project-fosse-relevage',
      category: 'waterTreatment',
      image: 'project-relevage-1.webp',
      featured: false,
      year: '2023-2024',
      translations: {
        en: {
          title: 'Construction of 5 Lifting Stations',
          client: 'Real Estate Developer',
          location: 'Tangier, Morocco',
          description: 'Construction of 5 lifting stations to facilitate wastewater management in a new residential complex, ensuring efficient operation.'
        },
        fr: {
          title: 'Réalisation de 5 fosses de relevage',
          client: 'Promoteur Immobilier',
          location: 'Tanger, Maroc',
          description: 'Construction de 5 fosses de relevage pour faciliter la gestion des eaux usées dans un nouveau complexe résidentiel, assurant un fonctionnement efficace.'
        },
        ar: {
          title: 'بناء 5 محطات رفع',
          client: 'مطور عقاري',
          location: 'طنجة، المغرب',
          description: 'بناء 5 محطات رفع لتسهيل إدارة مياه الصرف الصحي في مجمع سكني جديد، مما يضمن التشغيل الفعال.'
        }
      }
    },
    {
      id: 'project-irrigation-15ha',
      category: 'waterTreatment',
      image: 'project-sys-irr.webp',
      featured: true,
      year: '2021',
      translations: {
        en: {
          title: 'Implementation of an Irrigation System for 15 Hectares',
          client: 'Agricultural Farm',
          location: 'Tangier, Morocco',
          description: 'Installation of an advanced irrigation system for watering 15 hectares of agricultural land, optimizing water use and increasing yields.'
        },
        fr: {
          title: 'Réalisation d’un système d’irrigation pour 15 hectares',
          client: 'Exploitation Agricole',
          location: 'Tanger, Maroc',
          description: 'Mise en place d’un système d’irrigation avancé pour l’arrosage de 15 hectares de terres agricoles, optimisant l’utilisation de l’eau et augmentant les rendements.'
        },
        ar: {
          title: 'تنفيذ نظام ري لمساحة 15 هكتارًا',
          client: 'مزرعة زراعية',
          location: 'طنجة، المغرب',
          description: 'تركيب نظام ري متقدم لري 15 هكتارًا من الأراضي الزراعية، مما يحسن استخدام المياه ويزيد من الإنتاجية.'
        }
      }
    }
  ];
};

export default createProjectsData;